var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#E5E8EE","height":"2px"}})}
var staticRenderFns = []

export { render, staticRenderFns }